import React from "react";
import { Flex, Link, Span } from "@catchoftheday/cg-components";
import { URL_LOGIN } from "@catchoftheday/common-vendors";
import { CTAButton } from "../CTAButton";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var UpsellSecondaryCTA = function UpsellSecondaryCTA(_ref) {
  var tight = _ref.tight,
      isLoggedIn = _ref.isLoggedIn,
      onLoginClick = _ref.onLoginClick,
      onLinkClick = _ref.onLinkClick;
  return ___EmotionJSX(Flex, {
    alignItems: "center",
    justifyContent: "center",
    fontSize: "xs",
    mt: tight ? 1 : 4
  }, ___EmotionJSX(Span, {
    mr: 1,
    fontSize: "inherit",
    fontWeight: "medium",
    color: "onePass.textPrimary"
  }, "Already a member?"), !isLoggedIn ? ___EmotionJSX(Link, {
    onClick: onLoginClick,
    href: URL_LOGIN,
    fontSize: "inherit",
    fontWeight: "bold",
    color: "onePass.primary",
    textDecoration: "underline"
  }, "Log in") : ___EmotionJSX(CTAButton, {
    fontSize: "inherit",
    onClick: onLinkClick
  }, "Link OnePass with Catch"));
};